// SAS-based direct-to-blob upload.
// The backend issues a write-only SAS URL scoped to a _staging/<uuid>/<file>
// blob with a 15-min expiry. We PUT the file body directly to that URL; the
// returned `url` (without the SAS query string) is the persistent path that
// gets saved to the form state and submitted. On submit, the backend
// server-side copies the staging blob to its permanent supplier folder.

import { api } from "./api";

export async function uploadToBlob(
  file: File,
  kind: "logo" | "document",
): Promise<{ url: string; path: string }> {
  const { data } = await api.post<{ upload_url: string; blob_path: string }>("/blob/sas", {
    kind,
    filename: file.name,
  });

  const putResponse = await fetch(data.upload_url, {
    method: "PUT",
    headers: { "x-ms-blob-type": "BlockBlob" },
    body: file,
  });

  if (!putResponse.ok) {
    throw new Error(`Blob upload failed: ${putResponse.status} ${putResponse.statusText}`);
  }

  return { url: data.upload_url.split("?")[0], path: data.blob_path };
}
